module.exports = __webpack_public_path__ + "img/logo_transparent_bg.36730ea9.png";